<template>
  <v-card class="unselectable">
    <v-toolbar dense>
      <v-toolbar-title>Marks</v-toolbar-title>
      <v-spacer/>
      <v-btn small icon @click="show_marks_subcategory =!show_marks_subcategory">
        <v-icon v-if="show_marks_subcategory">mdi-chevron-up</v-icon>
        <v-icon v-else>mdi-chevron-down</v-icon>
      </v-btn>
    </v-toolbar>
    <template v-for="(category, idx) in marks">
      <v-card-actions class="justify-space-between" :key="'v'+idx">
        {{ category.name }} <v-chip>{{ category.value }}</v-chip>
      </v-card-actions>
      <v-divider :key="'d'+idx"/>
      <v-card-text class="py-1" :key="idx" v-show="show_marks_subcategory">
        <v-list-item v-for="(sub_category, i) in category.children" :key="i">
          <v-list-item-content v-text="sub_category.name"/>
          <v-list-item-action v-text="sub_category.value"/>
        </v-list-item>
      </v-card-text>
    </template>
    <v-divider/>
    <v-card-actions class="box-shadow justify-space-between success">
      <span>Total:</span> <span><v-chip>{{ final_mark }}</v-chip></span>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: {
    marks: {
      type: Array,
      default: Array
    },
    final_mark: {
      default: null,
    },
  },
  data: () => ({
    show_marks_subcategory: false
  })
}
</script>